import { c as _c } from "react/compiler-runtime";
import { alpha, Box } from "@mui/material";
import React, { useRef } from "react";
import { type ArrayItemData } from "#/entities/dataStructures/array/model/arraySlice";
import { NestedStructure } from "#/features/treeViewer/ui/NestedStructure";
import { NodeOverlay } from "#/features/treeViewer/ui/NodeOverlay";
import { useNodeAnimations, useNodeColors } from "#/shared/hooks";
import { safeStringify } from "#/shared/lib/stringifySolutionResult";
type MapItemProps = {
  item: ArrayItemData;
  colorMap?: Record<number | string, string> | null;
};
export const MapItem: React.FC<MapItemProps> = t0 => {
  const $ = _c(26);
  const {
    item,
    colorMap
  } = t0;
  const {
    key,
    value,
    childName,
    color,
    animation,
    animationCount
  } = item;
  const valueColor = colorMap?.[String(value)];
  const ref = useRef(null);
  const {
    nodeColor
  } = useNodeColors(color ?? valueColor, false);
  const nodeAnimation = useNodeAnimations(ref, animation, animationCount);
  const isChildNested = Boolean(childName);
  let t1;
  if ($[0] !== nodeColor) {
    t1 = nodeColor && alpha(nodeColor, 0.1);
    $[0] = nodeColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: 22,
      padding: "4px",
      "&.arrow": {
        opacity: 0.7,
        minWidth: "initial",
        padding: "initial"
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = {
      position: "relative",
      height: 44,
      backgroundColor: t1,
      td: t2
    };
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      textAlign: "center"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isChildNested || $[7] !== nodeAnimation) {
    t5 = <NodeOverlay ref={ref} animation={nodeAnimation} isChildNested={isChildNested} />;
    $[6] = isChildNested;
    $[7] = nodeAnimation;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== key) {
    t6 = safeStringify(key);
    $[9] = key;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <td style={t4}>{t5}{t6}</td>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <td className="arrow">⇒</td>;
    t9 = {
      position: "relative",
      zIndex: 20
    };
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isChildNested || $[17] !== item || $[18] !== value) {
    t10 = isChildNested ? <NestedStructure item={item} /> : safeStringify(value);
    $[16] = isChildNested;
    $[17] = item;
    $[18] = value;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <td style={t9}>{t10}</td>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t3 || $[24] !== t7) {
    t12 = <Box component="tr" sx={t3}>{t7}{t8}{t11}</Box>;
    $[22] = t11;
    $[23] = t3;
    $[24] = t7;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};